import { render, staticRenderFns } from "./listOfGames.vue?vue&type=template&id=39e97436&scoped=true&"
import script from "./listOfGames.vue?vue&type=script&lang=js&"
export * from "./listOfGames.vue?vue&type=script&lang=js&"
import style0 from "./listOfGames.vue?vue&type=style&index=0&id=39e97436&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e97436",
  null
  
)

export default component.exports